import type { FaireProductEntity } from "../../entity_types/product";

export const p_qvk64uadtg: FaireProductEntity = {
  token: "p_qvk64uadtg",
  type: "product",
  name: "925 Sterling Silver Exquisite Light Luxury Moissanite Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Gioiellin - S925 Silver Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/f9d037fac3cd73861678b897307aa4ffc218f4ed9ca712501104515d8b9cee4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8dd3a7f039dfbeb156d10a4ade34d6d19e07b8d552fceb12a4fe1beea3c10c7b.jpeg",
    "https://cdn.faire.com/fastly/69b71f72446f2c21d8d185e0f93b14547f48dea14680f4aea3496fc8b9351d29.jpeg",
    "https://cdn.faire.com/fastly/cc6d9e6d1f197407be035fb992ce34019a260294ae950d29f4be0c8bfdbc4ae0.jpeg",
    "https://cdn.faire.com/fastly/06ffcf94f4f282bfc8df311828b342d84bdb802217ebeb51ce5d19d1c5a9fc78.jpeg",
    "https://cdn.faire.com/fastly/c9a52b20ba4cad733e9999886fd376eaf478038788d547fdec7d9a300d8b8045.png",
  ],
  priceDollars: 21.48,
  description:
    "'-ID: GIO-WES-MORI2503\n-Material: S925 Sterling Silver\n-Electroplating Process: Electrophoretic Paint\n-Color: Silvery(Sterling Silver with Platinum Plating), Golden(Sterling Silver with 10k Gold Plating)\n-Main Stone(s): Moissanite(Synthetic), 1*1mm\n-Stone(s) Color: D\n-Stone(s) Clarlty: VVS1\n-Stone(s) Cut: 3EX\n-Size: 6,7,8 (Standard US Size)\n-Thick: 1.6mm\n-Weight(s): 1.33g\nShine with elegance in this moissanite engagement ring made of genuine 925 sterling silver. The brilliant round-cut moissanite sparkles like a real diamond, offering an affordable and ethical alternative. Its cushion halo design with side stones adds timeless charm and extra sparkle. Hypoallergenic and nickel-free, it's safe for daily wear. A perfect gift for engagements, proposals, anniversaries, or romantic moments. Comes in a luxury gift box to impress the one you love.",
  tags: [],
  msrpDollars: 42.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:26.705Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
